import {AccountService} from './services/account.service';
import {BlogService} from './services/blog.service';
import {CandidateClauseService} from './services/candidate-clause.service';
import {CertificateService} from './services/certificate.service';
import {ClauseService} from './services/clause.service';
import {ClientInterviewService} from './services/client-interview.service';
import {ConferenceService} from './services/conference.service';
import {ConnectionGraphService} from './services/connection.graph.service';
import {ContactService} from './services/contact.service';
import {CrawlerService} from './services/crawler.service';
import {DictService} from './services/dict.service';
import {EducationService} from './services/education.service';
import {EndStatisticsService} from './services/end-statistics.service';
import {ExperienceService} from './services/experience.service';
import {JobOrderService} from './services/job-order.service';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {ProjectService} from './services/project.service';
import {PublicationService} from './services/publication.service';
import {PhoneInterviewService} from './services/phone-interview.service';
import {RankingService} from './services/ranking.service';
import {ReportService} from './services/report.service';
import {RepositoryService} from './services/repository.service';
import {SessionService} from './session.service';
import {SkillService} from './services/skill.service';
import {SocialMediaService} from './services/social-media.service';
import {TimeTrackerService} from './services/time-tracker.service';
import {TrainingService} from './services/training.service';
import {UserService} from './services/user.service';
import {GithubConnectorService} from './services/github-connector.service';
import {CandidateQualificationService} from '@core/ecv-http-services/services/candidate-qualification.service';
import {SemanticEnrichmentService} from './services/semantic-enrichment.service';
import {DictAliasService} from '@core/ecv-http-services/services/dict-alias.service';
import {CoordinatorsService} from '@core/ecv-http-services/services/coordinators.service';
import {WebsiteClausesService} from '@core/ecv-http-services/services/website-clauses.service';
import {JoinedInterviewsService} from '@core/ecv-http-services/services/joined-interviews.service';
import {DeleteSpecialistService} from '@core/ecv-http-services/services/delete-specialist.service';

/**
 * A service module for all services responsible for http requests.
 */
@NgModule()
export class EcvHttpServicesModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: EcvHttpServicesModule,
      providers: [
        AccountService,
        BlogService,
        CandidateClauseService,
        CertificateService,
        ClauseService,
        ClientInterviewService,
        ConferenceService,
        ConnectionGraphService,
        ContactService,
        CrawlerService,
        DictService,
        EducationService,
        EndStatisticsService,
        ExperienceService,
        GithubConnectorService,
        JobOrderService,
        ProjectService,
        PublicationService,
        PhoneInterviewService,
        RankingService,
        ReportService,
        RepositoryService,
        SessionService,
        SkillService,
        SocialMediaService,
        TimeTrackerService,
        TrainingService,
        UserService,
        CandidateQualificationService,
        SemanticEnrichmentService,
        DictAliasService,
        CoordinatorsService,
        WebsiteClausesService,
        JoinedInterviewsService,
        DeleteSpecialistService
      ]
    };
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/core/ecv-http-services/ecv-http-services.module.ts